
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/certificates",
      function () {
        return require("private-next-pages/settings/certificates.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/certificates"])
      });
    }
  